module.exports = __webpack_public_path__ + "static/media/bordeaux.11bc6e00.jpg";